import { Form, Select } from 'antd'
import { FC } from 'react'
import { useGetContractorsQuery } from '../../../../../../../../../../store/api/contractors-api'
import { QueryParams } from '../../../../../../../../../../types/strapi/strapi'
import { requiredOneElementRules } from '../../../../../../../../../../constants/forms/validation/rules'

const params: QueryParams = {
    filters: { type: { name: { $contains: 'Производитель штампов' } } },
}

interface ContractorProps {}

const Contractor: FC<ContractorProps> = () => {
    const name = 'contractor'

    const { data } = useGetContractorsQuery(params)

    return (
        <Form.Item name={name} label={'Контрагент'} rules={requiredOneElementRules}>
            <Select
                options={data?.data.map(x => ({
                    label: x.name,
                    value: x.documentId,
                }))}
            />
        </Form.Item>
    )
}

export default Contractor
